const GMAIL_DOMAINS = new Set(['gmail.com', 'googlemail.com'])

export const DISPOSABLE_BLOCKED_MESSAGE =
  "Please sign up with a permanent email address (temporary inbox domains aren't supported)."

export const INVALID_EMAIL_MESSAGE = 'Enter a valid email address.'

export type EmailRejectReason = 'invalid' | 'disposable'

export type EmailValidationResult =
  | { ok: true; canonical: string }
  | { ok: false; reason: EmailRejectReason; message: string }

export function canonicalizeEmail(raw: string): string {
  const email = raw.trim().toLowerCase()
  if (email.split('@').length !== 2) {
    throw new Error(INVALID_EMAIL_MESSAGE)
  }

  const [localPart, domainPart] = email.split('@')
  let local = localPart
  let domain = domainPart
  if (!local || !domain) {
    throw new Error(INVALID_EMAIL_MESSAGE)
  }

  domain = domain.replace(/\.+$/, '')
  if (!domain) {
    throw new Error(INVALID_EMAIL_MESSAGE)
  }

  local = local.split('+')[0]
  if (!local) {
    throw new Error(INVALID_EMAIL_MESSAGE)
  }

  if (GMAIL_DOMAINS.has(domain)) {
    local = local.replace(/\./g, '')
    domain = 'gmail.com'
  }

  return `${local}@${domain}`
}

export function validateEmailForSignup(
  raw: string,
  isDisposableDomain: (domain: string) => boolean,
): EmailValidationResult {
  try {
    const canonical = canonicalizeEmail(raw)
    const domain = canonical.includes('@') ? canonical.slice(canonical.indexOf('@') + 1) : ''
    if (isDisposableDomain(domain)) {
      return { ok: false, reason: 'disposable', message: DISPOSABLE_BLOCKED_MESSAGE }
    }
    return { ok: true, canonical }
  } catch {
    return { ok: false, reason: 'invalid', message: INVALID_EMAIL_MESSAGE }
  }
}
